<template>
  <v-inventory-create
    v-if="access.create_stock_adjustmen"
    name="stock adjustment"
    no-additional-cost
    ref="stock"
    top_title="create_stock_adjustment"
  >
    <v-form v-model="is_valid">
      <v-layout row>
        <v-flex class="mx-3">
          <v-autocomplete
            v-model="params.reason"
            :label="$t('reason')"
            v-bind:items="reasons"
          />
        </v-flex>
        <v-flex class="mx-3">
          <v-autocomplete
            :label="$t('store')"
            v-model="params.service"
            v-bind:items="services"
            item-text="name"
            item-value="_id"
            :rules="[fieldRules.required]"
            ref="service"
          />
        </v-flex>
      </v-layout>
    </v-form>
    <br />
    <template #items>
      <v-form v-model="is_valid_items">
        <v-data-table
          v-bind:headers="headers[params.reason]"
          v-bind:items="items"
          :items-per-page="200000"
          disable-sort
          hide-default-footer
          :no-data-text="$t('you_have_not_selected_items_yet')"
        >
          <template #[`item.product_name`]="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.product_name }}</v-list-item-title>
              <v-list-item-subtitle>SKU {{ item.sku }}</v-list-item-subtitle>
              <v-list-item-subtitle
                v-if="item.barcode && item.barcode.length > 0"
              >
                Barcode
                <span v-for="(barcode, ind) in item.barcode" :key="ind">{{
                  barcode + ", "
                }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template #[`item.changed`]="{ item }">
            <v-text-field
              v-model.number="item.changed"
              :ref="'changed' + item._id"
              :rules="[fieldRules.require]"
              reverse
              type="number"
              @focus="$event.target.select()"
            />
          </template>
          <template #[`item.cost`]="{ item }">
            <vuetify-money
              v-model="item.cost"
              v-bind:options="
                item.cost_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              :suffix="item.cost_currency == 'usd' ? '$' : ''"
              :ref="'cost' + item._id"
              :rules="[fieldRules.require]"
              class="right"
            />
          </template>
          <template #[`item.stock_after`]="{ item }">
            {{
              params.reason == "receive"
                ? item.in_stock + item.changed
                  ? item.in_stock + item.changed
                  : ""
                : params.reason == "loss" ||
                  params.reason == "damage" ||
                  params.reason == "fee"
                ? item.in_stock - item.changed
                  ? item.in_stock - item.changed
                  : ""
                : ""
            }}
          </template>
          <template #[`item.remove`]="{ item }">
            <v-btn icon v-on:click="remove_item(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-form>
      <v-divider />
      <v-card-text>
        <v-search-items
          v-bind:label="$t('add_item')"
          v-bind:items="items_list"
          v-bind:selectedAct="add_item"
          v-bind:rules="items && items.length == 0 ? [fieldRules.required] : []"
          v-bind:searchItems="getItems"
          v-bind:loading_inv_items="loading_inv_items"
        ></v-search-items>
      </v-card-text>
    </template>
    <template #action>
      <v-btn v-on:click="cancel" text>{{ $t("cancel") }}</v-btn>
      <v-btn
        color="success"
        :loading="loading_stock_adjustment"
        text
        v-on:click="save"
        :disabled="saveDisabled"
        >{{ $t("save") }}</v-btn
      >
    </template>
    <v-dialog v-model="exist_dialog" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text"
          >This item has already been added</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="exist_dialog = false">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-inventory-create>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "TransferCreate",
  mixins: [Services],
  data: () => ({
    reasons: [
      { text: "Receive items", value: "receive" },
      { text: "Inventory count", value: "recount" },
      { text: "Loss", value: "loss" },
      { text: "Damage", value: "damage" },
    ],
    params: {
      reason: "receive",
      service: null,
    },
    items: [],
    items_list: [],
    item: null,
    exist_dialog: false,
    search_text: "123",
    loading_inv_items: false,
    loading_stock_adjustment: false,
    is_valid: false,
    is_valid_items: false,
  }),
  computed: {
    form() {
      const fObj = {
        service: this.params.service,
      };
      for (let i = 0; i < this.items.length; i++) {
        fObj["changed" + this.items[i]._id] = this.items[i].changed;
        fObj["cost" + this.items[i]._id] = this.items[i].cost;
      }
      return fObj;
    },
    saveDisabled() {
      let formHasErrors =
        !this.is_valid || !this.is_valid_items || this.items.length == 0;
      // Object.keys(this.form).forEach((f) => {
      //   if (!this.form[f]) formHasErrors = true;
      // });
      return formHasErrors;
    },
    target() {
      return this.$route.params["target"];
    },
    headers() {
      let headers = {
        receive: [
          { text: this.$t("item"), value: "product_name" },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            align: "right",
            width: 100,
          },
          {
            text: this.$t("add_stock"),
            value: "changed",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("cost"),
            value: "cost",
            align: "right",
            width: 100,
          },
        ],
        recount: [
          { text: this.$t("item"), value: "product_name" },
          {
            text: this.$t("expected_stock"),
            value: "in_stock",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("counted_stock"),
            value: "changed",
            width: 100,
            align: "right",
          },
          { text: null, value: "remove", align: "center", width: 50 },
        ],
        loss: [
          { text: this.$t("item"), value: "product_name" },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("remove_stock"),
            value: "changed",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("stock_after"),
            value: "stock_after",
            width: 100,
            align: "right",
          },
          { text: null, value: "remove", align: "center", width: 50 },
        ],
        damage: [
          { text: this.$t("item"), value: "product_name" },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("remove_stock"),
            value: "changed",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("stock_after"),
            value: "stock_after",
            width: 100,
            align: "right",
          },
          { text: null, value: "remove", align: "center", width: 50 },
        ],
        fee: [
          { text: this.$t("item"), value: "product_name" },
          {
            text: this.$t("in_stock"),
            value: "in_stock",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("remove_stock"),
            value: "changed",
            width: 100,
            align: "right",
          },
          {
            text: this.$t("stock_after"),
            value: "stock_after",
            width: 100,
            align: "right",
          },
          { text: null, value: "remove", align: "center", width: 50 },
        ],
      };
      // if (this.user_access && this.user_access.inv_stock_adjusment_cost) {
      //   headers["receive"].push({
      //     text: this.$t("cost"),
      //     value: "cost",
      //     align: "right",
      //     width: 100,
      //   });
      // }
      headers["receive"].push({
        text: this.$t("stock_after"),
        value: "stock_after",
        align: "right",
        width: 100,
      });
      headers["receive"].push({
        text: null,
        value: "remove",
        align: "center",
        width: 50,
      });
      return headers;
    },
    // user_access
  },
  watch: {
    "params.service"() {
      this.getItems(this.search_text, true);
      this.itemsRefresh();
    },
  },
  methods: {
    add_item(item) {
      let exist = false;
      for (const itm of this.items) {
        if (itm.product_id == item.product_id) {
          exist = true;
        }
      }
      if (exist) {
        this.exist_dialog = true;
      } else {
        this.items.push(this.$copy(item));
      }
    },
    remove_item(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    cancel() {
      if (this.target == "create") {
        this.$router.push({ path: "/inventory/stock" });
      } else {
        this.$router.push({
          path: "/inventory/stock/view",
          query: this.$route.query,
        });
      }
    },
    update() {
      this.getItems("");
    },
    async getItems(search, service_changed) {
      if (typeof search != typeof "invan") {
        search = "";
      }
      if (this.search_text == search && !service_changed) {
        return;
      }
      this.loading_inv_items = true;
      this.search_text = search;
      const items = this.$communicator.then(
        this,
        await this.$communicator("list_of_inv_items", {
          arguments: [50, 1],
          params: {
            service: this.params.service,
            search: search,
          },
        })
      );
      if (items && items instanceof Array) {
        var items_list = [];
        const inStockMap = {};
        for (const index in items) {
          let search_text =
            items[index].name +
            this.converter(items[index].name) +
            items[index].sku;
          if (
            items[index].barcode &&
            typeof items[index].barcode == typeof []
          ) {
            for (const b of items[index].barcode) {
              search_text += b;
            }
          }
          inStockMap[items[index]._id] = items[index].in_stock;
          items_list.push({
            product_id: items[index]._id,
            product_name: items[index].name,
            cost: items[index].cost,
            cost_currency: items[index].cost_currency,
            search_text: search_text,
            sku: items[index].sku,
            barcode: items[index].barcode,
            quality: null,
            in_stock: this.params.service ? items[index].in_stock : null,
            stock_after: items[index].stock_after,
          });
        }
        this.items_list = items_list;
      }
      this.loading_inv_items = false;
    },
    async itemsRefresh() {
      const ids = [];
      for (const itm of this.items) {
        ids.push(itm.product_id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_refresh", {
          params: {
            service: this.params.service,
            indexes: ids,
          },
        })
      );
      if (items) {
        const itemsMap = {};
        for (const itm of items) {
          itemsMap[itm._id] = itm;
        }
        for (const ind in this.items) {
          if (itemsMap[this.items[ind].product_id]) {
            this.items[ind].in_stock =
              itemsMap[this.items[ind].product_id].in_stock;
          }
        }
      }
    },
    async save() {
      this.loading_stock_adjustment = true;
      var params = this.$copy(
        Object.assign(this.params, this.$refs["stock"].options())
      );
      var items = [];
      for (const index in this.items) {
        const item1 = this.items[index];

        var item = {
          product_id: this.items[index].product_id,
          product_name: this.items[index].product_name,
          changed: this.items[index].changed,
          in_stock: this.items[index].in_stock,
        };
        if (this.items[index].cost) {
          item["cost"] = this.items[index].cost;
        }
        item["stock_after"] =
          params.reason == "receive"
            ? item1.in_stock + item1.changed
              ? item1.in_stock + item1.changed
              : ""
            : params.reason == "loss" ||
              params.reason == "damage" ||
              params.reason == "fee"
            ? item1.in_stock - item1.changed
              ? item1.in_stock - item1.changed
              : ""
            : "";
        items.push(item);
      }
      params.items = items;

      if (this.target == "create") {
        const response = this.$communicator.then(
          this,
          await this.$communicator("create_stock_adjustment", {
            params: params,
          })
        );
        this.$toast.success("Success", { timeout: 2000 });
        this.$router.push({
          path: "/inventory/stock/view",
          query: {
            id: response._id,
          },
        });
      }
      this.loading_stock_adjustment = false;
    },
  },
  mounted() {
    this.reasons = [
      { text: this.$t("receive_items"), value: "receive" },
      { text: this.$t("inventory_count"), value: "recount" },
      { text: this.$t("loss"), value: "loss" },
      { text: this.$t("damage"), value: "damage" },
      { text: this.$t("fee"), value: "fee" },
    ];

    this.update();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
